import { useEffect } from "react";
import PageEnum from "../../enum/PageEnum";
import { useAppDispatch } from "../../store/StoreHooks";
import { screenNameActions } from "../../store/screen/ScreenNameSlice";
import BaggageImg from "./Baggage.svg";
export const Baggage: React.FunctionComponent = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(screenNameActions.setScreenName(PageEnum.BreadcrumbEnum.Baggage));
  }, [dispatch]);
  return (
    <>
      <h1 className="amd-heading1">Baggage</h1>
      <section className="amd-section-shadow my-4">
        <img src={BaggageImg} alt="Baggage" width={"100%"} />
      </section>
    </>
  );
};
